import {
    USER_ASSESSMENT_REQUEST,
    USER_ASSESSMENT_SUCCESS,
    USER_ASSESSMENT_FAILURE,
    USER_ASSESSMENT_PRE_SIGNED_URL_REQUEST,
    USER_ASSESSMENT_PRE_SIGNED_URL_SUCCESS,
    USER_ASSESSMENT_PRE_SIGNED_URL_FAILURE,
    CREATE_ASSESSMENT_STEP_REQUEST,
    CREATE_ASSESSMENT_STEP_SUCCESS,
    CREATE_ASSESSMENT_STEP_FAILURE,
    GET_LAST_ASSESSMENT_REQUEST,
    GET_LAST_ASSESSMENT_SUCCESS,
    GET_LAST_ASSESSMENT_FAILURE,
    GET_ASSESSMENT_SUMMARY_REQUEST,
    GET_ASSESSMENT_SUMMARY_SUCCESS,
    GET_ASSESSMENT_SUMMARY_FAILURE,
    LIST_INTAKE_FORM_REQUEST,
    LIST_INTAKE_FORM_SUCCESS,
    LIST_INTAKE_FORM_FAILURE,
    CREATE_INTAKE_FORM_QUESTION_REQUEST,
    CREATE_INTAKE_FORM_QUESTION_SUCCESS,
    CREATE_INTAKE_FORM_QUESTION_FAILURE,
    GET_USER_INTAKE_QUESTIONS_REQUEST,
    GET_USER_INTAKE_QUESTIONS_SUCCESS,
    GET_USER_INTAKE_QUESTIONS_FAILURE,
    GET_USER_INTAKE_CIRCUIT_REQUEST,
    GET_USER_INTAKE_CIRCUIT_SUCCESS,
    GET_USER_INTAKE_CIRCUIT_FAILURE,
    GET_USER_ASSESSMENT_CIRCUIT_REQUEST,
    GET_USER_ASSESSMENT_CIRCUIT_SUCCESS,
    GET_USER_ASSESSMENT_CIRCUIT_FAILURE,
    CREATE_SINGLE_POSE_ASSSESSMENT_REQUEST,
    CREATE_SINGLE_POSE_ASSSESSMENT_SUCCESS,
    CREATE_SINGLE_POSE_ASSSESSMENT_FAILURE,
    RESET_SINGLE_ASSESSMENT_REPORT,
    GET_ASSESSMENT_DATA_REQUEST,
    GET_ASSESSMENT_DATA_SUCCESS,
    GET_ASSESSMENT_DATA_FAILURE,
    UPDATE_PROGRAM_DETAILS_REQUEST,
    UPDATE_PROGRAM_DETAILS_SUCCESS,
    UPDATE_PROGRAM_DETAILS_FAILURE
} from '../actions/types';

const initialState = {
    skipTestReason: null,
    assessments: null,
    userAssessmentRequest: false,
    userAssessmentSuccess: false,
    userAssessmentFailure: false,
    stepFileUrl: null,
    userAssessmentPreRequest: false,
    userAssessmentPreSuccess: false,
    userAssessmentPreFailure: false,
    assessmentStep: null,
    createAssessmentStepRequest: false,
    createAssessmentSuccess: false,
    createAssessmentFailure: false,
    lastAssessment: null,
    getLastAssessmentRequest: false,
    getLastAssessmentSuccess: false,
    getLastAssessmentFailure: false,
    allAssessment: null,
    assessmentSummaryRequest: false,
    assessmentSummarySuccess: false,
    assessmentSummaryFailure: false,
    intakeFormQuestions: null,
    intakeFormRequest: false,
    intakeFormSuccess: false,
    intakeFormFailure: false,
    createIntakeFormQuestionRequest: false,
    createIntakeFormQuestionSuccess: false,
    createIntakeFormQuestionFailure: false,
    singlePoseAssessmentRequest: false,
    singlePoseAssessmentSuccess: false,
    singlePoseAssessmentFailure: false,
    singleAssessmentReport: null,
    assessmentCircuit: null
};

function assessmentReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {

        case USER_ASSESSMENT_REQUEST:
            return {
                ...state,
                userAssessmentRequest: true,
                userAssessmentSuccess: false,
                userAssessmentFailure: false,
                assessments: null
            }
        case USER_ASSESSMENT_SUCCESS:
            return {
                ...state,
                userAssessmentRequest: false,
                userAssessmentSuccess: true,
                userAssessmentFailure: false,
                assessments: payload
            }
        case USER_ASSESSMENT_FAILURE:
            return {
                ...state,
                userAssessmentRequest: false,
                userAssessmentSuccess: false,
                userAssessmentFailure: true,
                assessments: null
            }

        case USER_ASSESSMENT_PRE_SIGNED_URL_REQUEST:
            return {
                ...state,
                userAssessmentPreRequest: true,
                userAssessmentPreSuccess: false,
                userAssessmentPreFailure: false,
                stepFileUrl: null
            }
        case USER_ASSESSMENT_PRE_SIGNED_URL_SUCCESS:
            return {
                ...state,
                userAssessmentPreRequest: false,
                userAssessmentPreSuccess: true,
                userAssessmentPreFailure: false,
                stepFileUrl: payload
            }
        case USER_ASSESSMENT_PRE_SIGNED_URL_FAILURE:
            return {
                ...state,
                userAssessmentPreRequest: false,
                userAssessmentPreSuccess: false,
                userAssessmentPreFailure: true,
                stepFileUrl: null
            }
        case CREATE_ASSESSMENT_STEP_REQUEST:
            return {
                ...state,
                createAssessmentStepRequest: true,
                createAssessmentSuccess: false,
                createAssessmentFailure: false,
                assessmentStep: null
            }
        case CREATE_ASSESSMENT_STEP_SUCCESS:
            return {
                ...state,
                createAssessmentStepRequest: false,
                createAssessmentSuccess: true,
                createAssessmentFailure: false,
                assessmentStep: payload,
                // Clear the assessment summary to force a refresh when viewing summary
                allAssessment: null,
                assessmentSummarySuccess: false
            }
        case CREATE_ASSESSMENT_STEP_FAILURE:
            return {
                ...state,
                createAssessmentStepRequest: false,
                createAssessmentSuccess: false,
                createAssessmentFailure: true,
                assessmentStep: null
            }
        case GET_LAST_ASSESSMENT_REQUEST:
            return {
                ...state,
                getLastAssessmentRequest: true,
                getLastAssessmentSuccess: false,
                getLastAssessmentFailure: false,
                lastAssessment: null
            }
        case GET_LAST_ASSESSMENT_SUCCESS:
            return {
                ...state,
                getLastAssessmentRequest: false,
                getLastAssessmentSuccess: true,
                getLastAssessmentFailure: false,
                lastAssessment: payload
            }
        case GET_LAST_ASSESSMENT_FAILURE:
            return {
                ...state,
                getLastAssessmentRequest: false,
                getLastAssessmentSuccess: false,
                getLastAssessmentFailure: true,
                lastAssessment: null
            }
        case GET_ASSESSMENT_SUMMARY_REQUEST:
            return {
                ...state,
                assessmentSummaryRequest: true,
                assessmentSummarySuccess: false,
                assessmentSummaryFailure: false,
                allAssessment: null
            }
        case GET_ASSESSMENT_SUMMARY_SUCCESS:
            return {
                ...state,
                assessmentSummaryRequest: false,
                assessmentSummarySuccess: true,
                assessmentSummaryFailure: false,
                allAssessment: payload
            }
        case GET_ASSESSMENT_SUMMARY_FAILURE:
            return {
                ...state,
                assessmentSummaryRequest: false,
                assessmentSummarySuccess: false,
                assessmentSummaryFailure: true,
                allAssessment: null
            }

        case LIST_INTAKE_FORM_REQUEST:
            return {
                ...state,
                intakeFormRequest: true,
                intakeFormSuccess: false,
                intakeFormFailure: false,
                intakeFormQuestions: null
            }
        case LIST_INTAKE_FORM_SUCCESS:

            return {
                ...state,
                intakeFormRequest: false,
                intakeFormSuccess: true,
                intakeFormFailure: false,
                intakeFormQuestions: payload
            }
        case LIST_INTAKE_FORM_FAILURE:
            return {
                ...state,
                intakeFormRequest: false,
                intakeFormSuccess: false,
                intakeFormFailure: true,
                intakeFormQuestions: null
            }

        case CREATE_INTAKE_FORM_QUESTION_REQUEST:
            return {
                ...state,
                createIntakeFormQuestionRequest: true,
                createIntakeFormQuestionSuccess: false,
                createIntakeFormQuestionFailure: false,
                intakeFormQuestion: null
            }
        case CREATE_INTAKE_FORM_QUESTION_SUCCESS:
            return {
                ...state,
                createIntakeFormQuestionRequest: false,
                createIntakeFormQuestionSuccess: true,
                createIntakeFormQuestionFailure: false,
                intakeFormQuestion: payload
            }
        case CREATE_INTAKE_FORM_QUESTION_FAILURE:
            return {
                ...state,
                createIntakeFormQuestionRequest: false,
                createIntakeFormQuestionSuccess: false,
                createIntakeFormQuestionFailure: true,
                intakeFormQuestion: null
            }

        case GET_USER_INTAKE_QUESTIONS_REQUEST:
            return {
                ...state,
                userIntakeQuestionRequest: true,
                userIntakeQuestionSuccess: false,
                userIntakeQuestionFailure: false,
                userIntakeFormQuestions: null
            }
        case GET_USER_INTAKE_QUESTIONS_SUCCESS:

            return {
                ...state,
                userIntakeQuestionRequest: false,
                userIntakeQuestionSuccess: true,
                userIntakeQuestionFailure: false,
                userIntakeFormQuestions: payload
            }
        case GET_USER_INTAKE_QUESTIONS_FAILURE:
            return {
                ...state,
                userIntakeQuestionRequest: false,
                userIntakeQuestionSuccess: false,
                userIntakeQuestionFailure: true,
                userIntakeFormQuestions: null
            }

        case GET_USER_INTAKE_CIRCUIT_REQUEST:
            return {
                ...state,
                intakeCircuitRequest: true,
                intakeCircuitSuccess: false,
                intakeCircuitFailure: false,
                circuit: null
            }
        case GET_USER_INTAKE_CIRCUIT_SUCCESS:

            return {
                ...state,
                intakeCircuitRequest: false,
                intakeCircuitSuccess: true,
                intakeCircuitFailure: false,
                circuit: payload
            }
        case GET_USER_INTAKE_CIRCUIT_FAILURE:
            return {
                ...state,
                intakeCircuitRequest: false,
                intakeCircuitSuccess: false,
                intakeCircuitFailure: true,
                circuit: null
            }

        case GET_USER_ASSESSMENT_CIRCUIT_REQUEST:
            return {
                ...state,
                assessmentCircuitRequest: true,
                assessmentCircuitSuccess: false,
                assessmentCircuitFailure: false,
                assessmentCircuit: null
            }
        case GET_USER_ASSESSMENT_CIRCUIT_SUCCESS:
            return {
                ...state,
                assessmentCircuitRequest: false,
                assessmentCircuitSuccess: true,
                assessmentCircuitFailure: false,
                assessmentCircuit: payload
            }
        case GET_USER_ASSESSMENT_CIRCUIT_FAILURE:
            return {
                ...state,
                assessmentCircuitRequest: false,
                assessmentCircuitSuccess: false,
                assessmentCircuitFailure: true,
                assessmentCircuit: null
            }


        case CREATE_SINGLE_POSE_ASSSESSMENT_REQUEST:
            return {
                ...state,
                singlePoseAssessmentRequest: true,
                singlePoseAssessmentSuccess: false,
                singlePoseAssessmentFailure: false,
                singleAssessmentReport: null
            }
        case CREATE_SINGLE_POSE_ASSSESSMENT_SUCCESS:
            return {
                ...state,
                singlePoseAssessmentRequest: false,
                singlePoseAssessmentSuccess: true,
                singlePoseAssessmentFailure: false,
                singleAssessmentReport: payload
            }
        case CREATE_SINGLE_POSE_ASSSESSMENT_FAILURE:
            return {
                ...state,
                singlePoseAssessmentRequest: false,
                singlePoseAssessmentSuccess: false,
                singlePoseAssessmentFailure: true,
                singleAssessmentReport: null
            }

        case RESET_SINGLE_ASSESSMENT_REPORT:
            return {
                ...state,
                singlePoseAssessmentRequest: false,
                singlePoseAssessmentSuccess: false,
                singlePoseAssessmentFailure: false,
                singleAssessmentReport: null
            };

        case GET_ASSESSMENT_DATA_REQUEST:
            return {
                ...state,
                assessmentTypeRequest: true,
                assessmentTypeSuccess: false,
                assessmentTypeFailure: false,
                assessmentTypesRes: null
            }
        case GET_ASSESSMENT_DATA_SUCCESS:

            return {
                ...state,
                assessmentTypeRequest: false,
                assessmentTypeSuccess: true,
                assessmentTypeFailure: false,
                assessmentTypesRes: payload
            }
        case GET_ASSESSMENT_DATA_FAILURE:
            return {
                ...state,
                assessmentTypeRequest: false,
                assessmentTypeSuccess: false,
                assessmentTypeFailure: true,
                assessmentTypesRes: null
            }

        case UPDATE_PROGRAM_DETAILS_REQUEST:
            return {
                ...state,
                updateProgramRequest: false,
                updateProgramSuccess: false,
                updateProgramFailure: true,
                programData: null
            }

        case UPDATE_PROGRAM_DETAILS_SUCCESS:
            return {
                ...state,
                updateProgramRequest: false,
                updateProgramSuccess: false,
                updateProgramFailure: true,
                programData: null
            }

        case UPDATE_PROGRAM_DETAILS_FAILURE:
            return {
                ...state,
                updateProgramRequest: false,
                updateProgramSuccess: false,
                updateProgramFailure: true,
                programData: null
            }

        default:
            return state;
    }
}

export default assessmentReducer;
